module.exports = __webpack_public_path__ + "static/media/txtar.72889d9b.svg";